export default {
    SUCCESS_SHORT: 'SUCCESS_SHORT',
    SUCCESS_LONG: 'SUCCESS_LONG',
    FAILURE_SHORT: 'FAILURE_SHORT',
    FAILURE_LONG: 'FAILURE_LONG',
    PAUSE: 'PAUSE',
};
